export default "__VITE_ASSET__xDCutI6W__$_?url__"